package team.platforma.chatdata.table

import app.cash.sqldelight.ExecutableQuery
import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class MokMessageQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun createMessageId(): ExecutableQuery<Long> = Query(1_953_516_179, driver,
      "MokMessage.sq", "createMessageId", "SELECT last_insert_rowid()") { cursor ->
    cursor.getLong(0)!!
  }

  public fun <T : Any> observeMessages(
    aiModelId: Long,
    userId: Long,
    chatId: Long,
    mapper: (
      id: Long,
      chatId: Long,
      aiModelId: Long,
      userId: Long,
      textMessage: String,
      status: String,
      senderId: Long,
    ) -> T,
  ): Query<T> = ObserveMessagesQuery(aiModelId, userId, chatId) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getLong(6)!!
    )
  }

  public fun observeMessages(
    aiModelId: Long,
    userId: Long,
    chatId: Long,
  ): Query<MokMessage> = observeMessages(aiModelId, userId, chatId) { id, chatId_, aiModelId_,
      userId_, textMessage, status, senderId ->
    MokMessage(
      id,
      chatId_,
      aiModelId_,
      userId_,
      textMessage,
      status,
      senderId
    )
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertMessage(
    chatId: Long,
    aiModelId: Long,
    userId: Long,
    textMessage: String,
    status: String,
    senderId: Long,
  ): Long {
    val result = driver.execute(1_029_478_139, """
        |INSERT INTO MokMessage (chatId, aiModelId, userId, textMessage, status, senderId)
        |VALUES (?, ?, ?, ?, ?, ?)
        """.trimMargin(), 6) {
          bindLong(0, chatId)
          bindLong(1, aiModelId)
          bindLong(2, userId)
          bindString(3, textMessage)
          bindString(4, status)
          bindLong(5, senderId)
        }.await()
    notifyQueries(1_029_478_139) { emit ->
      emit("MokMessage")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun updateMessage(
    chatId: Long,
    status: String,
    id: Long,
  ): Long {
    val result = driver.execute(45_035_243, """
        |UPDATE MokMessage
        |SET chatId = ?, status = ?
        |WHERE id = ?
        """.trimMargin(), 3) {
          bindLong(0, chatId)
          bindString(1, status)
          bindLong(2, id)
        }.await()
    notifyQueries(45_035_243) { emit ->
      emit("MokMessage")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun updateMessageText(
    chatId: Long,
    status: String,
    textMessage: String,
    id: Long,
  ): Long {
    val result = driver.execute(-1_468_040_520, """
        |UPDATE MokMessage
        |SET chatId = ?, status = ?, textMessage = ?
        |WHERE id = ?
        """.trimMargin(), 4) {
          bindLong(0, chatId)
          bindString(1, status)
          bindString(2, textMessage)
          bindLong(3, id)
        }.await()
    notifyQueries(-1_468_040_520) { emit ->
      emit("MokMessage")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteMessageById(id: Long): Long {
    val result = driver.execute(-230_833_349, """
        |DELETE FROM MokMessage
        |WHERE id = ?
        """.trimMargin(), 1) {
          bindLong(0, id)
        }.await()
    notifyQueries(-230_833_349) { emit ->
      emit("MokMessage")
    }
    return result
  }

  private inner class ObserveMessagesQuery<out T : Any>(
    public val aiModelId: Long,
    public val userId: Long,
    public val chatId: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("MokMessage", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("MokMessage", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(194_422_581, """
    |SELECT MokMessage.id, MokMessage.chatId, MokMessage.aiModelId, MokMessage.userId, MokMessage.textMessage, MokMessage.status, MokMessage.senderId
    |FROM MokMessage
    |WHERE aiModelId = ? AND userId = ? AND chatId = ?
    """.trimMargin(), mapper, 3) {
      bindLong(0, aiModelId)
      bindLong(1, userId)
      bindLong(2, chatId)
    }

    override fun toString(): String = "MokMessage.sq:observeMessages"
  }
}
